import script from "./QLicensePlate.vue?vue&type=script&setup=true&lang=js"
export * from "./QLicensePlate.vue?vue&type=script&setup=true&lang=js"

import "./QLicensePlate.vue?vue&type=style&index=0&id=aa2b1d30&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2b1d30"]])

export default __exports__